export const INIT_CHAT_REQUESTED = 'INIT_CHAT_REQUESTED';
export const INIT_CHAT_SUCCEEDED = 'INIT_CHAT_SUCCEEDED';
export const INIT_CHAT_FAILED = 'INIT_CHAT_FAILED';

export const SET_CONVERSATIONS_LIST = 'SET_CONVERSATIONS_LIST';
export const UPDATE_CONVERSATION = 'UPDATE_CONVERSATION';
export const INSERT_CONVERSATION = 'INSERT_CONVERSATION';
export const REMOVE_CONVERSATION = 'REMOVE_CONVERSATION';

export const SELECT_CONVERSATION_REQUESTED = 'SELECT_CONVERSATION_REQUESTED';
export const SELECT_CONVERSATION_SUCCEEDED = 'SELECT_CONVERSATION_SUCCEEDED';
export const SELECT_CONVERSATION_FAILED = 'SELECT_CONVERSATION_FAILED';

export const INSERT_CHAT_MESSAGE = 'INSERT_CHAT_MESSAGE';
export const INSERT_CHAT_DRAFT_MESSAGE = 'INSERT_CHAT_DRAFT_MESSAGE';
export const DELETE_CHAT_MESSAGE = 'DELETE_CHAT_MESSAGE';
export const DELETE_CHAT_DRAFT_MESSAGES = 'DELETE_CHAT_DRAFT_MESSAGES';
export const EDIT_CHAT_MESSAGE = 'EDIT_CHAT_MESSAGE';
export const HANDLE_NOT_SENT_MESSAGE = 'HANDLE_NOT_SENT_MESSAGE';

export const USER_TYPING_START = 'USER_TYPING_START';
export const USER_TYPING_STOP = 'USER_TYPING_STOP';

export const SEND_CHAT_MESSAGE_REQUESTED = 'SEND_CHAT_MESSAGE_REQUESTED';
export const SEND_CHAT_MESSAGE_SUCCEEDED = 'SEND_CHAT_MESSAGE_SUCCEEDED';
export const SEND_CHAT_MESSAGE_FAILED = 'SEND_CHAT_MESSAGE_FAILED';

export const SEND_CHAT_REACTION_REQUESTED = 'SEND_CHAT_REACTION_REQUESTED';
export const UPDATE_CHAT_MESSAGE_REACTIONS = 'UPDATE_CHAT_MESSAGE_REACTIONS';

export const END_CONVERSATION_REQUESTED = 'END_CONVERSATION_REQUESTED';
export const END_CONVERSATION_SUCCEEDED = 'END_CONVERSATION_SUCCEEDED';
export const END_CONVERSATION_FAILED = 'END_CONVERSATION_FAILED';

export const END_CONVERSATION_FOR_OPERATOR_REQUESTED = 'END_CONVERSATION_FOR_OPERATOR_REQUESTED';

export const OPEN_FORWARD_DIALOG = 'OPEN_FORWARD_DIALOG';
export const CLOSE_FORWARD_DIALOG = 'CLOSE_FORWARD_DIALOG';

export const FORWARD_CONVERSATION_REQUESTED = 'FORWARD_CONVERSATION_REQUESTED';
export const FORWARD_CONVERSATION_SUCCEEDED = 'FORWARD_CONVERSATION_SUCCEEDED';
export const FORWARD_CONVERSATION_FAILED = 'FORWARD_CONVERSATION_FAILED';

export const UPDATE_SELECTED_CONVERSATION = 'UPDATE_SELECTED_CONVERSATION';

export const LOAD_OLDER_MESSAGES_REQUESTED = 'LOAD_OLDER_MESSAGES_REQUESTED';
export const LOAD_OLDER_MESSAGES_SUCCEEDED = 'LOAD_OLDER_MESSAGES_SUCCEEDED';
export const LOAD_OLDER_MESSAGES_FAILED = 'LOAD_OLDER_MESSAGES_FAILED';

export const CLEAR_SELECTED_CONVERSATION = 'CLEAR_SELECTED_CONVERSATION';

export const DESTROY_CHAT = 'DESTROY_CHAT';

export const SET_MESSAGE_SEEN = 'SET_MESSAGE_SEEN';



// WEBPACK FOOTER //
// ./src/services/chat/actionTypes.js